import { render, staticRenderFns } from "./SetPointModal.vue?vue&type=template&id=2ed09d20&scoped=true"
import script from "./SetPointModal.vue?vue&type=script&lang=js"
export * from "./SetPointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed09d20",
  null
  
)

export default component.exports